import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6094155a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sign_up_box" }
const _hoisted_2 = { class: "input_box email" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "signUpEmail" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "xi-mail-o" })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "error_message"
}
const _hoisted_5 = { class: "input_box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "signUpName" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "xi-user" })
], -1))
const _hoisted_7 = { class: "input_box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "signUpPassword" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "xi-lock-o" })
], -1))
const _hoisted_9 = { class: "input_box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "signUpConfirmPassword" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "xi-lock-o" })
], -1))
const _hoisted_11 = {
  key: 1,
  class: "error_message"
}
const _hoisted_12 = { class: "input_box" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "signUpNickName" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "xi-user-o" })
], -1))
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "sign_up_cancel_btn" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xi-angle-left-min" }, null, -1))

import { storeToRefs } from 'pinia';

import useCommonStore from '@/store/storeCommon';
import useMemberStore from '@/store/storeMember';


export default /*#__PURE__*/_defineComponent({
  __name: 'Signup',
  setup(__props) {

const { inputValueAni, showModal, showSignupToggle, disabledQualification, modalContents } = useCommonStore();
const { isLoading, isMainLogo, isSatelliteInfo } = storeToRefs(useCommonStore());
const { accessSignup, errorMessage, emailRegex, signupForm } = useMemberStore();
const { confirmPassword } = storeToRefs(useMemberStore());

/**
 *  회원가입을 실행합니다.
 */
const submitSignupFunction = async (): Promise<void> => {
  try {
    isLoading.value = true;

    const response = await accessSignup();

    if (response) {
      showModal.isSuccess = true;
      confirmPassword.value = '';
      errorMessage.confirmPassword = '';

      isMainLogo.value = true;
      isSatelliteInfo.value = false;

      Object.assign(signupForm, {
        email: '',
        name: '',
        password: '',
        nickname: '',
      });
      Object.assign(modalContents, {
        title: 'Welcome!',
        description: '회원가입이 성공하였습니다.\n로그인해 주세요.',
      });
    }
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

/**
 *  blur 시, 이메일 유효성 검사 & 비밀번호 확인하고 에러 메세지를 표시합니다.
 */
const errorSignupVerification = (): void => {
  if (!emailRegex.test(signupForm.email) && signupForm.email) {
    errorMessage.email = '올바르지 못한 이메일 형식입니다.';
  }
  if (emailRegex.test(signupForm.email) && signupForm.email && (errorMessage.email !== '이미 등록된 이메일입니다.')) {
    errorMessage.email = '';
  }
  if (confirmPassword.value !== signupForm.password) {
    errorMessage.confirmPassword = '비밀번호가 다릅니다.';
  }
  if (!confirmPassword.value) {
    errorMessage.confirmPassword = '';
  }
};

/**
 * 조건별 함수
 */
const qualificationFunction = (qualification: string): boolean => {
  switch (qualification) {
    case 'showEmailErrorMessage':
      return !!(errorMessage.email && signupForm.email);
    case 'showConfirmErrorMessage':
      return !!errorMessage.confirmPassword && (signupForm.password !== confirmPassword.value);
    case 'disabledSignup':
      return !(signupForm.email && emailRegex.test(signupForm.email) && signupForm.name && signupForm.nickname && signupForm.password) || signupForm.password !== confirmPassword.value;
    default:
      return false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        id: "signUpEmail",
        type: "text",
        placeholder: "EMAIL",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(signupForm).email) = $event)),
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(inputValueAni) && _unref(inputValueAni)(...args))),
        onBlur: errorSignupVerification
      }, null, 544), [
        [_vModelText, _unref(signupForm).email]
      ])
    ]),
    (qualificationFunction('showEmailErrorMessage'))
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(errorMessage).email), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        id: "signUpName",
        type: "text",
        placeholder: "NAME",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(signupForm).name) = $event)),
        onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(inputValueAni) && _unref(inputValueAni)(...args)))
      }, null, 544), [
        [_vModelText, _unref(signupForm).name]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _withDirectives(_createElementVNode("input", {
        id: "signUpPassword",
        type: "password",
        placeholder: "PASSWORD",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(signupForm).password) = $event)),
        onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(inputValueAni) && _unref(inputValueAni)(...args)))
      }, null, 544), [
        [_vModelText, _unref(signupForm).password]
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _withDirectives(_createElementVNode("input", {
        id: "signUpConfirmPassword",
        type: "password",
        placeholder: "CONFIRM PASSWORD",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(confirmPassword) ? (confirmPassword).value = $event : null)),
        onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(inputValueAni) && _unref(inputValueAni)(...args))),
        onBlur: errorSignupVerification
      }, null, 544), [
        [_vModelText, _unref(confirmPassword)]
      ])
    ]),
    (qualificationFunction('showConfirmErrorMessage'))
      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(qualificationFunction("showConfirmErrorMessage") ? _unref(errorMessage).confirmPassword : ""), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _withDirectives(_createElementVNode("input", {
        id: "signUpNickName",
        type: "text",
        placeholder: "NICKNAME",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(signupForm).nickname) = $event)),
        onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(inputValueAni) && _unref(inputValueAni)(...args)))
      }, null, 544), [
        [_vModelText, _unref(signupForm).nickname]
      ])
    ]),
    _createElementVNode("button", {
      class: "sign_up_btn",
      type: "button",
      disabled: qualificationFunction('disabledSignup'),
      onClick: submitSignupFunction
    }, " Sign up ", 8, _hoisted_14),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        type: "button",
        disabled: _unref(disabledQualification)(),
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(showSignupToggle) && _unref(showSignupToggle)(...args)))
      }, [
        _hoisted_17,
        _createTextVNode(" Cancel ")
      ], 8, _hoisted_16)
    ])
  ]))
}
}

})